import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, DisplayS } from '@sorare/core/src/atoms/typography';
import { ResponsiveImg } from '@sorare/core/src/atoms/ui/ResponsiveImg';
import { mediumMobileHeightAndAbove } from '@sorare/core/src/style/mediaQuery';

import { useNBAEvents } from '@sorare/gameplay/src/lib/events';

import commonCardPack from '@sorare/nba/src/components/onboarding/S3Onboarding/assets/commonCardPack.png';

const Wrapper = styled(Vertical)`
  flex: 1;
  position: relative;
  align-items: center;
  gap: var(--double-unit);
  justify-content: space-between;

  & > * {
    z-index: 1;
    position: relative;
  }
`;

const TextContent = styled(Vertical)`
  display: flex;
  position: relative;
  align-items: center;

  @media ${mediumMobileHeightAndAbove} {
    margin-top: var(--triple-unit);
  }
  padding-inline: var(--double-unit);
`;

const Img = styled(ResponsiveImg)`
  width: 65%;
  max-width: 270px;
`;

const ButtonWrapper = styled.div`
  width: 100%;
  padding: var(--double-unit);
  display: flex;
  gap: var(--unit);
`;

type Props = {
  setStep: (step: number) => void;
};

export const StarterPack = ({ setStep }: Props) => {
  const track = useNBAEvents();

  useEffect(() => {
    track('View Onboarding Starter pack');
  }, [track]);

  return (
    <Wrapper>
      <TextContent>
        <DisplayS brand className="text-center">
          <FormattedMessage
            id="StarterPack.title"
            defaultMessage="Starter pack"
          />
        </DisplayS>
        <BodyM color="var(--c-neutral-700)" className="text-center">
          <FormattedMessage
            id="S3Onboarding.StarterPack.subtitle"
            defaultMessage="Tap to reveal your first Sorare NBA Pack!"
          />
        </BodyM>
      </TextContent>
      <Button size="large" color="transparent" onClick={() => setStep(7)}>
        <Img src={commonCardPack} alt="" />
      </Button>
      <ButtonWrapper>
        <Button
          onClick={() => setStep(7)}
          color="secondary"
          fullWidth
          size="large"
        >
          <FormattedMessage
            id="S3Onboarding.StarterPack.cta"
            defaultMessage="Tap to reveal"
          />
        </Button>
      </ButtonWrapper>
    </Wrapper>
  );
};
